import { useContext, useEffect, useRef, useState } from "react";
import PermissionContext from "./PermissionContext";
import { Permission } from "./PermissionProvider";

const usePermission = (permission: Permission) => {
	const [loading, setLoading] = useState(true);
	const [allowed, setAllowed] = useState<boolean>();
	const isMountedRef = useRef(true); // Persist across renders

	const { isAllowedTo } = useContext(PermissionContext);

	useEffect(() => {
		isMountedRef.current = true; // Prevents setting state if component unmounts
		setLoading(true);
		const result = isAllowedTo(permission);
		if (isMountedRef.current) {
			setAllowed(result);
			setLoading(false);
		}
		return () => {
			isMountedRef.current = false; // Cleanup function, prevent updates if unmounted
		};
	}, [permission, isAllowedTo]); // Re-run when permission changes

	return [loading, allowed] as const;
};

export default usePermission;
